import * as React from 'react';
import { BodyCell } from '@tableau/widgets-datagrid';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { ExtractEncryptionState, IDataSourceInfo } from '../../../../ts/models/IDataSourceInfo';
import { DataSources } from '../../../../content/resources/Datasources';
import { DateTimeText } from './DateTimeCells';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { SpaceHeaderStyles } from '../../Header/SpaceHeaderStyles';
import { ActivitySpinnerSize, ActivitySpinnerWidget } from '@tableau/widgets';
import { ExtractEncryptionMode } from '../../../../sites/SitePropertyTypes';

export function LastRefreshedCell(isExtractEncryptionEnabled: boolean, siteEaRMode: ExtractEncryptionMode): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function(props: BodyCell.Props) {
        const datasource = props.row.data as IDataSourceInfo;

        const labelStyle: React.CSSProperties = {
          marginRight: 18,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        };

        function contentText(): string {
          const dateTimeOptions = {...props, propertyName: 'lastRefreshedAt'};
          // &emsp; = unicode 8195
          return `${DataSources.ExtractStatusOrLive(isExtractEncryptionEnabled, datasource.hasExtracts,
              datasource.extractEncryptionState, datasource.extractCreationPending, siteEaRMode)}${String.fromCharCode(8195)}${DateTimeText(dateTimeOptions)}`;
        }

        return (
            <div style={labelStyle} title={contentText()}>
              {
                FeatureFlags.extractMoveToTheWebEnabled && (datasource.extractEncryptionState === ExtractEncryptionState.pendingDecryption ||
                    datasource.extractEncryptionState === ExtractEncryptionState.pendingEncryption ||
                    (!datasource.hasExtracts && datasource.extractCreationPending))
                    ?
                    <span key={1} aria-busy="true" className={SpaceHeaderStyles.ExtractStatusSpinner}>
                  <ActivitySpinnerWidget testId="extract-status" spinnerSize={ActivitySpinnerSize.Small}/>
            </span>
                    : null
              }
              {contentText()}
            </div>
        );
      }
  );
}
